/**
 * @documental
 * @export Option
 * @name
 * Dropdown.Option
 */

import { FC, ReactNode } from "react";

/**
 * The `Option` component properties.
 */
export interface OptionProps {
  /**
   * The optional plain text label used for screen readers and search.
   * If not specified the content is used instead.
   * If specified and no content is specified the label is used instead.
   */
  readonly label?: string;

  /**
   * The option value.
   */
  readonly value: string | number;

  /**
   * The option children.
   */
  readonly children?: ReactNode;
}

/**
 * A single option for the `Dropdown` component.
 */
export const Option: FC<OptionProps> = () => {
  return null;
};
